import { create } from "zustand";
import { persist } from "zustand/middleware";
import { requestNotificationPermission, playNotificationSound, showEmailNotification } from "../utils/notification";

interface NotificationState {
  notificationsEnabled: boolean;
  soundEnabled: boolean;
  permission: NotificationPermission;
  installPrompt: any | null;
  setSoundEnabled: (enabled: boolean) => void;
  setInstallPrompt: (prompt: any) => void;
  enableNotifications: () => Promise<boolean>;
  checkPermission: () => void;
  testNotification: () => void;
}

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set, get) => ({
      notificationsEnabled: false,
      soundEnabled: true,
      permission: typeof window !== "undefined" && "Notification" in window ? Notification.permission : "default",
      installPrompt: null,

      setSoundEnabled: (enabled: boolean) => {
        set({ soundEnabled: enabled });
      },

      setInstallPrompt: (prompt: any) => {
        set({ installPrompt: prompt });
      },

      checkPermission: () => {
        if (typeof window !== "undefined" && "Notification" in window) {
          set({
            permission: Notification.permission,
            notificationsEnabled: Notification.permission === "granted" && get().notificationsEnabled,
          });
        }
      },

      enableNotifications: async () => {
        const result = await requestNotificationPermission();
        const isGranted = result === "granted";
        set({
          permission: result,
          notificationsEnabled: isGranted,
        });
        if (isGranted) {
          if (get().soundEnabled) {
            playNotificationSound();
          }
          await showEmailNotification({
            title: "MagicMail Webmail",
            body: "¡Notificaciones activadas con éxito!",
          });
        }
        return isGranted;
      },

      testNotification: async () => {
        if (get().soundEnabled) {
          playNotificationSound();
        }
        
        let perm = typeof window !== "undefined" && "Notification" in window ? Notification.permission : "default";
        if (perm !== "granted") {
          perm = await requestNotificationPermission();
          set({ permission: perm, notificationsEnabled: perm === "granted" });
        }

        if (perm === "granted") {
          await showEmailNotification({
            title: "MagicMail Webmail",
            body: "¡Las notificaciones están funcionando correctamente en tu Mac!",
          });
        } else {
          console.warn("Permiso de notificaciones no otorgado:", perm);
        }
      },
    }),
    {
      name: "magicmail-notifications-config",
      partialize: (state) => ({
        notificationsEnabled: state.notificationsEnabled,
        soundEnabled: state.soundEnabled,
      }),
    }
  )
);
